import { useCallback, useMemo } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { IconButton } from 'src/components/Buttons';
import { useAppContext } from 'src/contexts/AppContext';
import { vars } from 'src/core/themes';
import { MainRoute } from 'src/navigations/Routes/MainRoute';
import { FullPageIcon } from 'src/svgs';
import { ContentId } from 'src/utils/constants/contentId';
import { createPurchaseEventPageUrl } from 'src/utils/purchaseUtils';
import { createSaleEventPageUrl } from 'src/utils/saleUtils';
import { Event } from 'src/WebApiController';

export const FullPageEventAction = ({ event }: { event: Event }) => {
  const navigate = useNavigate();
  const { mainRoute } = useAppContext();

  const eventUrl = useMemo(() => {
    if (mainRoute === MainRoute.Sales) {
      return createSaleEventPageUrl(event.virtId);
    } else {
      return createPurchaseEventPageUrl(event.virtId);
    }
  }, [event.virtId, mainRoute]);

  const onViewClick = useCallback(
    (eventUrl: string) => {
      if (event) {
        window.location.replace(`#${event.virtId}`);
        setTimeout(() => {
          navigate(eventUrl, {
            state: {
              returnUrl: `${location.pathname}${location.search}#${event.virtId}`,
            },
          });
        }, 10);
      }
    },
    [event, navigate]
  );

  return (
    <Link
      to={eventUrl}
      style={{ height: vars.iconSize.l }}
      onClick={(e) => {
        if (e.button === 0 && e.getModifierState('Control') === false) {
          // Perform like a button click when it's a left-click (and no Ctrl)
          // Else the click will be whatever <a /> does
          e.preventDefault();
          e.stopPropagation();

          onViewClick(eventUrl);
        }
      }}
    >
      <IconButton
        icon={
          <FullPageIcon
            fill={vars.color.textBrand}
            size={vars.iconSize.m}
            withHoverEffect
          />
        }
        titleContentId={ContentId.OpenEventPage}
      />
    </Link>
  );
};
